import { createFileRoute } from "@tanstack/react-router";
import { AdminVenueAmbianceTagsTab } from "@/components/admin/pages/AdminVenueAmbianceTagsTab";

export const Route = createFileRoute("/pulse-ops-x7k2/target-cities/ambiance-tags")({
  component: AdminVenueAmbianceTagsTab,
});
